import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagarcab() {



  const cardData = {




keyword: "Pune to Sambhajinagar Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Sambhajinagar Cab Service for families, couples, business travelers, students, senior citizens, and groups planning a convenient intercity journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, business visits, family functions, religious tours, heritage trips, and customized Sambhajinagar travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes the journey convenient and comfortable. Travelers can also customize their itinerary to explore historic caves, temples, forts, lakes, and nearby destinations around Chhatrapati Sambhajinagar.",

topPlaces: [
  {
    title: "Ajanta Caves",
    description: "Ajanta Caves are a world-famous heritage attraction featuring ancient Buddhist rock-cut caves, sculptures, and remarkable paintings. The site is an excellent destination for history enthusiasts, families, photographers, and cultural travelers visiting Sambhajinagar. Customers booking a Pune to Sambhajinagar cab can customize their journey to include Ajanta Caves with comfortable private transportation and flexible sightseeing arrangements."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are one of Maharashtra's most important heritage attractions and feature Buddhist, Hindu, and Jain rock-cut monuments created over several centuries. The magnificent Kailasa Temple is a major highlight of the complex. Garud Cab Service provides chauffeur-driven transportation from Pune, allowing travelers to conveniently include Ellora in their Sambhajinagar sightseeing itinerary."
  },
  {
    title: "Bibi Ka Maqbara",
    description: "Bibi Ka Maqbara is one of Chhatrapati Sambhajinagar's most recognizable historical monuments and is known for its Mughal-era architecture and landscaped surroundings. The monument is popular among families, history enthusiasts, and photographers. Travelers from Pune can comfortably reach the attraction using a private cab and continue to other city landmarks according to their preferred schedule."
  },
  {
    title: "Grishneshwar Temple",
    description: "Grishneshwar Temple is a revered Shiva temple located near Ellora and is traditionally recognized as one of the twelve Jyotirlingas. Devotees frequently combine the temple with Ellora Caves during religious and heritage tours. Customers traveling from Pune can book a private cab with flexible timings and conveniently include Grishneshwar in a customized pilgrimage itinerary."
  },
  {
    title: "Daulatabad Fort",
    description: "Daulatabad Fort is an impressive historic hill fort known for its strategic location, strong defensive architecture, steep approaches, and panoramic views. It is an important destination for travelers interested in Maharashtra's medieval history. Garud Cab Service can arrange comfortable private transportation from Pune and include Daulatabad with Ellora and other nearby attractions."
  },
  {
    title: "Panchakki",
    description: "Panchakki is a historic water mill complex in Chhatrapati Sambhajinagar known for its traditional engineering system and association with the city's medieval heritage. It offers visitors an interesting combination of architecture, history, and water management. Travelers booking a Pune to Sambhajinagar cab can include Panchakki in a city sightseeing route with convenient private transportation."
  },
  {
    title: "Goga Baba Hill",
    description: "Goga Baba Hill is a scenic elevated location near Sambhajinagar that provides panoramic views of the surrounding city and landscape. It is popular with visitors looking for peaceful surroundings, photography, and sunrise or sunset experiences. A private cab from Pune allows travelers to include the hill in a flexible sightseeing itinerary along with other nearby attractions."
  },
  {
    title: "Siddharth Garden",
    description: "Siddharth Garden is a popular recreational destination in Sambhajinagar featuring gardens, open spaces, and family-friendly attractions. It provides a relaxed environment for visitors after exploring the city's historic landmarks. Garud Cab Service offers comfortable local transportation as part of a customized Pune to Sambhajinagar cab itinerary."
  },
  {
    title: "Salim Ali Lake",
    description: "Salim Ali Lake is a peaceful natural attraction in Chhatrapati Sambhajinagar and is associated with birdwatching and the city's green surroundings. It is suitable for travelers looking for a quieter sightseeing experience away from crowded monuments. Customers can include the lake in their private cab itinerary while exploring other attractions across Sambhajinagar."
  },
  {
    title: "Paithan",
    description: "Paithan is a historic town near Sambhajinagar known for its religious importance, Paithani textile heritage, Godavari River surroundings, and attractions around the Jayakwadi Dam. Travelers from Pune can combine Paithan with Sambhajinagar as part of a longer sightseeing journey. Garud Cab Service provides flexible one-way, round-trip, and customized multi-destination cab options."
  }
],



"services": [
  {
    "name": "Pune to Sambhajinagar Cab",
    "description": "Book Pune to Sambhajinagar Cab for comfortable and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, business travelers, tourists, and individuals looking for private travel from Pune to Sambhajinagar."
  },
  {
    "name": "Pune to Sambhajinagar Taxi",
    "description": "Choose Pune to Sambhajinagar Taxi for a comfortable and practical journey between Pune and Sambhajinagar. Sedan, SUV, Innova, and premium vehicle options can be arranged according to passenger requirements, luggage, and travel preferences."
  },
  {
    "name": "Pune to Sambhajinagar Cab Service",
    "description": "Book Pune to Sambhajinagar Cab Service for reliable chauffeur-driven transportation with convenient pickup arrangements. The service is suitable for families, corporate passengers, tourists, and travelers planning personal or long-distance journeys."
  },
  {
    "name": "Pune to Sambhajinagar Taxi Service",
    "description": "Choose Pune to Sambhajinagar Taxi Service for private intercity travel with comfortable AC vehicles and experienced drivers. Customers can select suitable vehicle categories for business trips, family journeys, sightseeing, and personal travel requirements."
  },
  {
    "name": "Cab from Pune to Sambhajinagar",
    "description": "Reserve a Cab from Pune to Sambhajinagar for direct and comfortable transportation with convenient pickup from your preferred Pune location. The service is suitable for individuals, families, corporate travelers, and tourists requiring private long-distance travel."
  },
  {
    "name": "Taxi from Pune to Sambhajinagar",
    "description": "Book a Taxi from Pune to Sambhajinagar for a convenient point-to-point journey with professional chauffeur assistance. Comfortable sedan, SUV, and larger vehicle options are available for passengers traveling for business, family visits, tourism, or personal requirements."
  },
  {
    "name": "Pune to Sambhajinagar Outstation Cab",
    "description": "Choose Pune to Sambhajinagar Outstation Cab for comfortable long-distance transportation outside Pune. The service provides private chauffeur-driven travel suitable for families, business travelers, tourists, and passengers planning scheduled intercity journeys."
  },
  {
    "name": "Pune to Aurangabad Cab",
    "description": "Book Pune to Aurangabad Cab for convenient private transportation from Pune to Aurangabad. Comfortable AC vehicles and professional chauffeurs make the service suitable for families, corporate travelers, tourists, and passengers traveling for personal or business purposes."
  },
  {
    "name": "Pune to Aurangabad Taxi",
    "description": "Choose Pune to Aurangabad Taxi for a comfortable intercity journey with flexible pickup arrangements and experienced drivers. Sedan, SUV, and premium cab options can be selected according to passenger count, luggage, and travel requirements."
  },
  {
    "name": "Pune to Aurangabad Cab Service",
    "description": "Book Pune to Aurangabad Cab Service for convenient chauffeur-driven transportation between Pune and Aurangabad. The service is suitable for family trips, business travel, sightseeing, personal visits, and travelers requiring direct private transportation."
  },
  {
    "name": "Pune to Aurangabad Taxi Service",
    "description": "Choose Pune to Aurangabad Taxi Service for comfortable and convenient long-distance travel with professional chauffeurs. Well-maintained AC vehicles can be arranged for individuals, families, tourists, and corporate passengers."
  },
  {
    "name": "Cab from Pune to Aurangabad",
    "description": "Reserve a Cab from Pune to Aurangabad for direct private transportation with convenient pickup from Pune. The service is suitable for business travelers, families, tourists, and individuals looking for a comfortable chauffeur-driven journey."
  },
  {
    "name": "Pune to Aurangabad Outstation Cab",
    "description": "Book Pune to Aurangabad Outstation Cab for comfortable intercity transportation with professional driver assistance. The service is suitable for long-distance family travel, corporate journeys, sightseeing trips, religious visits, and personal transportation."
  },
  {
    "name": "Pune to Sambhajinagar Cab Booking",
    "description": "Make Pune to Sambhajinagar Cab Booking for a scheduled private journey with convenient vehicle selection and pickup arrangements. Sedan, SUV, Innova, and premium options can be selected based on passenger requirements and luggage."
  },
  {
    "name": "Pune to Sambhajinagar Taxi Booking Online",
    "description": "Book Pune to Sambhajinagar Taxi Booking Online for convenient advance travel planning without visiting a booking office. Customers can arrange chauffeur-driven vehicles according to their preferred pickup time, passenger count, vehicle category, and journey requirements."
  },
  {
    "name": "Pune to Sambhajinagar Cab Fare",
    "description": "Check Pune to Sambhajinagar Cab Fare according to the selected vehicle category, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, and premium options can be arranged for comfortable private transportation."
  },
  {
    "name": "Pune to Sambhajinagar Taxi Charges",
    "description": "Check Pune to Sambhajinagar Taxi Charges based on the vehicle selected and overall journey requirements. Customers can choose practical sedan, spacious SUV, Innova, or premium vehicles for family trips, business travel, and long-distance journeys."
  },
  {
    "name": "Pune to Sambhajinagar Cab Price",
    "description": "Find Pune to Sambhajinagar Cab Price according to vehicle type, pickup location, travel schedule, and journey requirements. Comfortable chauffeur-driven cars can be arranged for individuals, families, corporate passengers, and tourists."
  },
  {
    "name": "Best Pune to Sambhajinagar Cab Service",
    "description": "Choose the Best Pune to Sambhajinagar Cab Service for comfortable private transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for business travel, family journeys, sightseeing, and personal trips."
  },
  {
    "name": "Cheap Pune to Sambhajinagar Cab",
    "description": "Book a Cheap Pune to Sambhajinagar Cab for economical private transportation without compromising on basic travel comfort. Sedan and other practical vehicle options can be arranged for individuals, families, students, business travelers, and budget-conscious passengers."
  },
  {
    "name": "Pune to Sambhajinagar One Way Cab",
    "description": "Choose Pune to Sambhajinagar One Way Cab for convenient point-to-point transportation without requiring a return booking. The service is suitable for relocation, business travel, family visits, personal trips, and passengers traveling to Sambhajinagar for a one-way journey."
  },
  {
    "name": "Pune to Sambhajinagar Round Trip Taxi",
    "description": "Book Pune to Sambhajinagar Round Trip Taxi for convenient travel with return transportation included in the journey plan. The service is suitable for families, corporate travelers, tourists, and passengers planning meetings, sightseeing, visits, or extended stays."
  },
  {
    "name": "Pune to Sambhajinagar Innova Cab",
    "description": "Choose Pune to Sambhajinagar Innova Cab for spacious and comfortable transportation suitable for families and small groups. The vehicle offers practical seating and luggage space for long-distance travel, business trips, sightseeing, and personal journeys."
  },
  {
    "name": "Pune to Sambhajinagar Innova Crysta Cab",
    "description": "Book Pune to Sambhajinagar Innova Crysta Cab for premium and spacious intercity travel with comfortable interiors and professional chauffeur service. It is suitable for families, executives, corporate passengers, tourists, and groups seeking enhanced comfort."
  },
  {
    "name": "Pune to Sambhajinagar Ertiga Cab",
    "description": "Choose Pune to Sambhajinagar Ertiga Cab for comfortable group travel with practical seating and luggage capacity. The vehicle is suitable for families, small groups, corporate passengers, and travelers looking for convenient long-distance transportation."
  },
  {
    "name": "Pune to Sambhajinagar Sedan Cab",
    "description": "Book Pune to Sambhajinagar Sedan Cab for comfortable AC transportation suitable for individuals, couples, and small families. Sedan travel provides practical seating and luggage space for business trips, personal visits, and long-distance journeys."
  },
  {
    "name": "Pune to Sambhajinagar SUV Taxi",
    "description": "Choose Pune to Sambhajinagar SUV Taxi for spacious and comfortable transportation with additional seating and luggage capacity. The service is suitable for families, groups, corporate travelers, tourists, and passengers planning a longer road journey."
  },
  {
    "name": "Pune to Sambhajinagar AC Cab",
    "description": "Book Pune to Sambhajinagar AC Cab for comfortable climate-controlled travel throughout the journey. The service is suitable for families, business travelers, tourists, and individuals who prefer private transportation with professional chauffeur assistance."
  },
  {
    "name": "Pune to Sambhajinagar Ajanta Ellora Cab",
    "description": "Choose Pune to Sambhajinagar Ajanta Ellora Cab for convenient private travel to the historic Ajanta and Ellora attractions. The service is suitable for families, tourists, history enthusiasts, and groups planning sightseeing with comfortable chauffeur-driven transportation."
  },
  {
    "name": "Pune to Sambhajinagar Business Travel Taxi",
    "description": "Book Pune to Sambhajinagar Business Travel Taxi for comfortable and professional transportation for meetings, corporate visits, client appointments, and work-related journeys. Sedan, SUV, and premium vehicles can be arranged according to business travel requirements."
  },
  {
    "name": "Pune to Sambhajinagar Family Trip Cab",
    "description": "Choose Pune to Sambhajinagar Family Trip Cab for spacious and comfortable transportation for family journeys. Suitable vehicle options can accommodate passengers and luggage while providing convenient pickup, private travel, and direct destination drop."
  },
  {
    "name": "Pune to Sambhajinagar Religious Tour Cab",
    "description": "Book Pune to Sambhajinagar Religious Tour Cab for comfortable private transportation for pilgrimage and religious travel. The service is suitable for families, devotees, senior passengers, and groups planning temple visits and other spiritual journeys around Sambhajinagar."
  }
],
"tableData": [
  ["Pune to Sambhajinagar Cab", "Pune to Sambhajinagar Taxi"],
  ["Pune to Sambhajinagar Cab Service", "Pune to Sambhajinagar Taxi Service"],
  ["Cab from Pune to Sambhajinagar", "Taxi from Pune to Sambhajinagar"],
  ["Pune to Sambhajinagar Outstation Cab", "Pune to Aurangabad Cab"],
  ["Pune to Aurangabad Taxi", "Pune to Aurangabad Cab Service"],
  ["Pune to Aurangabad Taxi Service", "Cab from Pune to Aurangabad"],
  ["Pune to Aurangabad Outstation Cab", "Pune to Sambhajinagar Cab Booking"],
  ["Pune to Sambhajinagar Taxi Booking Online", "Pune to Sambhajinagar Cab Fare"],
  ["Pune to Sambhajinagar Taxi Charges", "Pune to Sambhajinagar Cab Price"],
  ["Best Pune to Sambhajinagar Cab Service", "Cheap Pune to Sambhajinagar Cab"],
  ["Pune to Sambhajinagar One Way Cab", "Pune to Sambhajinagar Round Trip Taxi"],
  ["Pune to Sambhajinagar Innova Cab", "Pune to Sambhajinagar Innova Crysta Cab"],
  ["Pune to Sambhajinagar Ertiga Cab", "Pune to Sambhajinagar Sedan Cab"],
  ["Pune to Sambhajinagar SUV Taxi", "Pune to Sambhajinagar AC Cab"],
  ["Pune to Sambhajinagar Ajanta Ellora Cab", "Pune to Sambhajinagar Business Travel Taxi"],
  ["Pune to Sambhajinagar Family Trip Cab", "Pune to Sambhajinagar Religious Tour Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Sambhajinagar Cab for Convenient Intercity Travel",
    WhyChoosedescription: "Garud Cab Service offers private Pune to Sambhajinagar cab transportation for families, professionals, students, couples, and groups travelling for personal visits, business work, education, family functions, or other planned journeys."
  },
  {
    WhyChooseheading: "Direct Journey with Convenient Pickup",
    WhyChoosedescription: "Travel directly from your preferred location in Pune to your destination in Sambhajinagar without changing vehicles, making the journey convenient for passengers travelling with family members or luggage."
  },
  {
    WhyChooseheading: "Suitable for Family & Personal Trips",
    WhyChoosedescription: "Families can arrange a private cab for family visits, social occasions, personal appointments, functions, or other travel requirements while keeping the entire group together."
  },
  {
    WhyChooseheading: "Useful for Business & Professional Travel",
    WhyChoosedescription: "The cab service can support office visits, client meetings, industrial requirements, project work, site inspections, professional appointments, and other business-related journeys."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Transportation",
    WhyChoosedescription: "Book a one-way cab when you need a direct drop in Sambhajinagar for relocation, work, education, personal travel, or family visits without requiring the vehicle for the return trip."
  },
  {
    WhyChooseheading: "Round-Trip Option for Planned Visits",
    WhyChoosedescription: "Travellers who need to return to Pune can arrange a round-trip cab according to their appointment, family program, work schedule, sightseeing plan, or preferred return timing."
  },
  {
    WhyChooseheading: "Vehicle Options Based on Travel Needs",
    WhyChoosedescription: "Select a suitable vehicle according to your passenger count, luggage quantity, trip purpose, and desired comfort level for the Pune to Sambhajinagar journey."
  },
  {
    WhyChooseheading: "Arrange Your Journey with Garud Cab Service",
    WhyChoosedescription: "Share your Pune pickup point, Sambhajinagar destination, travel date, passenger details, luggage requirements, preferred vehicle, and trip type with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Sambhajinagar Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Sambhajinagar cab services for families, professionals, students, couples, groups, and passengers travelling for various personal and business purposes."
  },
  {
    question: "Can I book a one-way cab from Pune to Sambhajinagar?",
    answer: "Yes, one-way cab service is available for passengers who require direct transportation from Pune to their preferred destination in Sambhajinagar."
  },
  {
    question: "Can I book a round-trip Pune to Sambhajinagar cab?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Sambhajinagar visit, family plans, business schedule, appointment, or preferred return date."
  },
  {
    question: "Is Pune to Sambhajinagar cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to travel together with convenient pickup, comfortable seating, and luggage arrangements."
  },
  {
    question: "Can I use the cab for business travel?",
    answer: "Yes, the cab can be used for office visits, client meetings, industrial work, site inspections, professional appointments, and other business-related travel."
  },
  {
    question: "Can I book a cab for a family function in Sambhajinagar?",
    answer: "Yes, private transportation can be arranged for weddings, family functions, social events, personal visits, and other planned occasions in Sambhajinagar."
  },
  {
    question: "Can I book a cab for relocation to Sambhajinagar?",
    answer: "Yes, a private cab can be considered for relocation or personal shifting requirements, subject to the seating and luggage capacity of the selected vehicle."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can the cab drop me directly at my Sambhajinagar location?",
    answer: "Yes, direct drop-off can be arranged at your home, hotel, office, residential area, business location, or another accessible destination in Sambhajinagar."
  },
  {
    question: "How can I book a Pune to Sambhajinagar Cab?",
    answer: "Share your Pune pickup location, Sambhajinagar destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Omkar Shinde",
    feedback: "We booked a Pune to Sambhajinagar cab for a family visit and found private travel convenient for our group. Having the vehicle throughout the journey also made carrying our luggage easier.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja More",
    feedback: "I arranged a cab from Pune to Sambhajinagar for personal work. The direct road journey was convenient and helped me plan the trip around my schedule.",
    rating: 5
  }
];



















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sambhajinagar Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-sambhajinagar-cab.webp",
  "description": "Book Pune to Sambhajinagar Cab with Garud Cab for safe, comfortable, and reliable intercity travel. Get Pune to Sambhajinagar taxi and cab services for one way trips, round trips, business travel, family journeys, sightseeing, and convenient city-to-city transportation with Sedan, Ertiga, SUV, Innova, and Innova Crysta options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-sambhajinagar-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Sambhajinagar Cab | Taxi & One Way Cab Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Sambhajinagar Cab with Garud Cab for comfortable and reliable intercity travel. Get one way and round trip taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for family, business, and sightseeing trips."
  />

  <meta
    name="keywords"
    content="Pune to Sambhajinagar Cab, Pune to Sambhajinagar Taxi, Pune to Sambhajinagar Cab Service, Pune to Sambhajinagar Taxi Service, Cab from Pune to Sambhajinagar, Taxi from Pune to Sambhajinagar, Pune to Sambhajinagar One Way Cab, Pune to Sambhajinagar Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/114.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosambhajinagarcab;